import React from 'react';
import { Button, Grid, Icon, Typography } from '@mui/material';
import { formatValue } from '../utils';
import { Field, RecordValue } from '../utils/types';

interface AddRemoveItemProps {
  onClick?: Function | undefined;
  icon?: 'add' | 'remove';
  value: RecordValue;
  recordId?: string;
  field?: Field;
}

const AddRemoveItem: React.FC<AddRemoveItemProps> = ({
  icon = 'add',
  value: itemValue,
  onClick = undefined,
  field,
}) => {
  const formattedValue = formatValue(
    itemValue.value,
    field?.controlField?.Control,
  );
  const iconPropsMap = {
    add: {
      iconSrc: '/icons/plus.svg',
      altText: 'Add Item',
    },
    remove: {
      iconSrc: '/icons/minus.svg',
      altText: 'Remove Item',
    },
  };

  const iconProps = iconPropsMap[icon];
  const svgIcon = (
    <Icon sx={{ width: 32, height: 32, ml: 1 }}>
      <img alt={iconProps.altText} src={iconProps.iconSrc} />
    </Icon>
  );

  return (
    <Grid container size={12}>
      {onClick && (
        <Grid
          container
          sx={{ width: 32, mr: 1 }}
          justifyContent="center"
          alignItems="flex-start"
          direction="column"
        >
          <Button
            startIcon={svgIcon}
            disableRipple
            disableElevation
            disableFocusRipple
            size="small"
            onClick={(e) => onClick(e, itemValue)}
            sx={{
              minWidth: 32,
              px: 0,
              bgcolor: 'transparent',
            }}
          />
        </Grid>
      )}
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        direction="column"
        size="grow"
      >
        <Typography sx={{ px: 1 }} variant="body1">
          {formattedValue}
        </Typography>
      </Grid>
    </Grid>
  );
};

interface AddRemoveProps {
  values: any;
  onClick?: Function | undefined;
  field: Field;
  icon: 'add' | 'remove';
}

const AddRemove: React.FC<AddRemoveProps> = ({
  field,
  values,
  onClick,
  icon,
}) => {
  // const icon = 'remove' as const;
  const getItemsFromValues = (value: any, type: 'add' | 'remove') => {
    const props = { icon, onClick, field };

    if (!values.map) return null;

    return values.map((value: RecordValue, key: number) => {
      return <AddRemoveItem key={key} {...props} value={value} />;
    });
  };

  return (
    <Grid container size={12}>
      <Grid container sx={{ mb: 1.5 }}>
        <Grid size={12}>
          <Typography
            sx={{ px: 1 }}
            variant="body1"
            fontWeight="fontWeightBold"
          >
            {field.metadata?.Name}
          </Typography>
        </Grid>
        {getItemsFromValues(values, icon)}
      </Grid>
    </Grid>
  );
};

export { AddRemoveItem, AddRemove };
